import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileHeaderBar = _resolveComponent("MobileHeaderBar")!

  return (_openBlock(), _createBlock(_component_MobileHeaderBar, _mergeProps({
    icon: "icon-calendar",
    "header-text": _ctx.getHeaderText
  }, _ctx.$attrs), null, 16, ["header-text"]))
}